import { render, staticRenderFns } from "./AmsSolutionPage.vue?vue&type=template&id=7133de80"
import script from "./AmsSolutionPage.vue?vue&type=script&lang=js"
export * from "./AmsSolutionPage.vue?vue&type=script&lang=js"
import style0 from "./AmsSolutionPage.vue?vue&type=style&index=0&id=7133de80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports